import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-shipments',
    templateUrl: './shipments.component.html',
    styleUrls: ['./shipments.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class ShipmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
